import { service } from "@ember/service";
import Route from "@ember/routing/route";
import { task } from "ember-concurrency";
import destroyRecord from "glesys-controlpanel/utils/destroy-record";
import ENV from "glesys-controlpanel/config/environment";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class ServerBackupRoute extends Route {
  @service http;
  @service router;
  @service store;

  model() {
    let { project, server } = this.modelFor("server");
    let dataCenters = this.store.peekAll("data-center");
    let backups = server.get("backups");

    return {
      server,
      project,
      dataCenters,
      backups,
      restoreBackupTask: this.restoreBackupTask,
      createManualBackupTask: this.createManualBackupTask,
      deleteManualBackupTask: this.deleteManualBackupTask,
    };
  }

  redirect({ server }) {
    if (!server.isKVM) {
      this.router.transitionTo("server");
    }
  }

  restoreBackupTask = task(async (backup, dataCenter) => {
    let { project } = this.modelFor("server");

    const { content } = await this.http.request({
      url: `${ENV.apiBaseUri}/server/createfrombackup`,
      method: "POST",
      body: {
        backupid: backup.id,
        datacenter: dataCenter,
      },
    });

    await project.hasMany("servers").reload();

    this.router.transitionTo("server.details", content.server.serverid);
  });

  createManualBackupTask = task(async (server) => {
    let backup = await this.store.createRecord("server-backup", { server });
    await this.store.request(saveRecord(backup));
  });

  deleteManualBackupTask = task(async (backup) => {
    await destroyRecord(backup);
  });
}
